import { useLocation } from 'react-router-dom';
import { formatVid } from '../../utils/event';
import { images } from '../../config/colors';
import tocBackgroundFallback from '../../assets/tocBackground.jpg';
import styles from './ScanHelpPage.module.css';

const tocBackground = images.background || tocBackgroundFallback;

interface LocationState {
  account?: {
    vid?: string;
  };
}

export function ScanHelpPage() {
  const location = useLocation();
  const { account } = (location.state as LocationState) || {};

  const vid = formatVid(account?.vid);

  return (
    <div
      className={styles.background}
      style={{ backgroundImage: `url(${tocBackground})` }}
    >
      <div className={styles.container}>
        <div className={styles.spacer} />
        <p className={styles.label}>Visual ID:</p>
        <p className={styles.vid}>{vid}</p>
        <div className={styles.spacer} />
      </div>
    </div>
  );
}

export default ScanHelpPage;
